export const LEGAL_TYPE = {
  INDIVIDUAL: 'individual',
  COMPANY: 'company',
};

export const LEGAL_TYPES = Object.values(LEGAL_TYPE);
